import React from "react";
import styled from "styled-components";

const Wrapper = styled.div<{ image: string; ratio: number }>`
	${(props) => props.theme.layout.full_image(props.image)};
	padding-top: ${(props) => `${props.ratio}%`};
`;

const SourceImage: React.FC<{ image: string; className?: string; ratio?: number }> = ({ image, className, ratio = 56 }) => {
	return <Wrapper className={className} image={image} ratio={ratio} />;
};

export default SourceImage;
